/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheCosmicApplication.vue?vue&type=template&id=b08b7cac&scoped=true"
import script from "./TheCosmicApplication.ts?vue&type=script&lang=ts&external"
export * from "./TheCosmicApplication.ts?vue&type=script&lang=ts&external"
import style0 from "./TheCosmicApplication.vue?vue&type=style&index=0&id=b08b7cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b7cac",
  null
  
)

export default component.exports